import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=ae2a6a56&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=ae2a6a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2a6a56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae2a6a56')) {
      api.createRecord('ae2a6a56', component.options)
    } else {
      api.reload('ae2a6a56', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=ae2a6a56&scoped=true&", function () {
      api.rerender('ae2a6a56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-484pp4dbPaoN5/JS/comp/GuestBox.vue"
export default component.exports